import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';

function BackButton(props) {
  return (
    <Button {...props} light onClick={() => props.onClick()}>
      {props.value}
    </Button>
  );
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/BackButton/index.jsx